import { Box, Typography, TypographyProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { Column, Row, StackProps } from "@rui/Stack";

import LinearGradientBox from "../LinearGradientBox";

export const BarWrapper = styled(Row)({
  position: "relative",
  width: "100%",
  margin: "0 8px",
});

export const Bar = styled(Row)({
  minWidth: "50px",
  height: "10px",
  borderRadius: "2px",
  flex: 1,
});

const LabelLine = styled(Box)(({ theme }) => ({
  width: "1px",
  height: "33px",
  borderLeft: `1px dashed ${theme.palette.shades.neutral[300]}`,
}));

const LabelText = styled((props: TypographyProps) => (
  <Typography variant="labelMed" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[400],
}));

export const Label = styled(({ children, ...props }: StackProps) => (
  <Column variant="center" {...props}>
    <LabelLine />
    <LabelText>{children}</LabelText>
  </Column>
))({
  position: "absolute",
  top: -9,
  transform: "translateX(-50%)",
});

export const RangeLabel = styled((props: TypographyProps) => (
  <Row variant="center" sx={{ minWidth: "32px" }}>
    <Typography variant="bodySecondaryMed" {...props} />
  </Row>
))(({ theme }) => ({
  color: theme.palette.shades.neutral[500],
}));

interface HighlightedRangeProps {
  start: number;
  end: number;
}

export const HighlightedRange = styled(
  ({ start: _start, end: _end, ...props }: HighlightedRangeProps) => (
    <LinearGradientBox {...props} />
  )
)(({ start, end }) => ({
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  left: `${start}%`,
  right: `${end}%`,
  height: "16px",
}));
